<template>
  <div
    class="modal"
    tabindex="-1"
    aria-hidden="true"
    ref="setAvatarModal"
    data-backdrop="static"
  >
    <div class="modal-dialog">
      <div class="modal-content rounded-lg">
        <div class="modal-header justify-end pt-5 pb-0 border-0">
          <a
            data-dismiss="modal"
            href="javascript:;"
            class="font-poppins text-theme-23 font-medium hover:text-theme-35"
          >
            Cerrar
          </a>
        </div>
        <div class="px-10">
          <div class="modal-body pt-0">
            <h1
              class="font-crimson_pro text-theme-9 text-3xl font-bold text-center"
            >
              Elige un avatar
            </h1>
            <div class="grid grid-cols-3 gap-4 max-h-72 overflow-y-auto mt-5">
              <div
                v-for="imageKey in avatarIndexImages"
                :key="imageKey"
                class="cursor-pointer flex justify-center rounded-xl"
                @click="avatarSelected = imageKey"
              >
                <div
                  class="px-4 py-2"
                  :class="{
                    'border-2': imageKey === avatarSelected,
                    'border-theme-13': imageKey === avatarSelected
                  }"
                >
                  <img
                    :src="getAvatarImage(imageKey)"
                    :alt="'Image ' + imageKey"
                    class="object-contain h-24 rounded-3xl"
                    crossorigin="anonymous"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-right">
            <div class="flex flex-col">
              <button
                type="button"
                :disabled="!checkValidation"
                @click="$emit('setAvatarAction', { avatarSelected })"
                class="btn btn-quotation rounded-lg px-5 w-full sm:w-9/12 text-base mx-auto"
              >
                Usar
              </button>
              <button
                type="button"
                data-dismiss="modal"
                class="btn btn-quotation-outline rounded-lg px-5 mt-5 mb-3 w-full sm:w-9/12 text-base mx-auto"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    imageProfile: {
      type: String
    }
  },
  data() {
    return {
      avatarSelected: undefined,
      avatarIndexImages: [1, 2, 3, 4, 5, 6]
    }
  },
  emits: ['setAvatarAction'],
  methods: {
    viewModal(view = 'show') {
      if (view === 'show') {
        this.avatarSelected = this.avatarIndexImages.find((imageKey) =>
          this.imageProfile.includes(`user${imageKey}.png`)
        )
      }
      return cash(this.modal).modal(view)
    },
    getAvatarImage(imageKey) {
      return require(`@/assets/images/COT-img/avatares/user${imageKey}.png`)
    }
  },
  mounted() {
    this.modal = this.$refs.setAvatarModal
  },
  computed: {
    checkValidation() {
      return this.avatarSelected
    }
  }
}
</script>
